export const FETCH_SECTIONMAP_START = 'FETCH_SECTIONMAP_START';
export const FETCH_SECTIONMAP_SUCCESS = 'FETCH_SECTIONMAP_SUCCESS';
export const FETCH_SECTIONMAP_FAILURE = 'FETCH_SECTIONMAP_FAILURE';